//
export const CREDENCIALES_LISTA_CREDENCIALES = "CREDENCIALES/LISTA_CREDENCIALES"
export const CREDENCIALES_LISTA_CREDENCIALES_SUCCESS =
  "CREDENCIALES/LISTA_CREDENCIALES_SUCCESS"
export const CREDENCIALES_LISTA_CREDENCIALES_FAIL =
  "CREDENCIALES/LISTA_CREDENCIALES_FAIL"
export const CREDENCIALES_UNSET_LISTA_CREDENCIALES =
  "CREDENCIALES/UNSET_LISTA_CREDENCIALES"

export const CREDENCIALES_LOGOUT = "CREDENCIALES/LOGOUT"

// export const AUTH_LOGIN = "auth/LOGIN"
// export const AUTH_LOGIN_SUCCESS = "auth/LOGIN_SUCCESS"
// export const AUTH_LOGIN_ERROR = "auth/LOGIN_ERROR"
// export const AUTH_LOGOUT = "auth/LOGOUT"
// export const AUTH_API_ERROR = "auth/LOGIN_API_ERROR"
// export const AUTH_ACCOUNT_SETUP = "auth/ACCOUNT_SETUP"
// export const AUTH_CONFIRM_USER = "auth/CONFIRM_USER"
// export const AUTH_SOCIAL_LOGIN = "auth/SOCIAL_LOGIN"
// export const AUTH_SET_IDCOLEGIO = "auth/SETIDCOLEGIO"
